import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {SimpleObjectValue} from '../../shared/models/simple-object';


export const playerAdoptionFamiliesActionTypes = {
  LOAD: type('[Player Adoption Families] LOAD'),
  LOAD_SUCCESS: type('[Player Adoption Families] LOAD Success'),
  LOAD_FAIL: type('[Player Adoption Families] LOAD Fail')
};

export class LoadPlayerAdoptionFamiliesAction implements Action {
  readonly type = playerAdoptionFamiliesActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadSuccessPlayerAdoptionFamiliesAction implements Action {
  readonly type = playerAdoptionFamiliesActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any[]) {}
}

export class LoadFailPlayerAdoptionFamiliesAction implements Action {
  readonly type = playerAdoptionFamiliesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
